/**
 * 値オブジェクト基底クラス
 *
 * すべての値オブジェクトはこのクラスを継承する。
 * TypeScriptのナローイングを活用した改善版
 */
export abstract class ValueObject<T> {
  protected readonly value: T;

  protected constructor(value: T) {
    this.value = value;
  }

  /**
   * 値の等価性を判定（TypeScriptナローイング活用）
   */
  public equals(other: ValueObject<T> | null | undefined): boolean {
    if (!other) return false;

    if (!(other instanceof ValueObject)) {
      return false;
    }

    // プリミティブ値の比較
    if (this.isPrimitive(this.value) && this.isPrimitive(other.value)) {
      return this.value === other.value;
    }

    // オブジェクトの深い比較（必要に応じて）
    return JSON.stringify(this.value) === JSON.stringify(other.value);
  }

  /**
   * プリミティブ値かどうかを判定
   */
  private isPrimitive(value: unknown): value is string | number | boolean | symbol | bigint {
    return value !== Object(value);
  }

  /**
   * プリミティブ値を取得
   */
  public getValue(): T {
    return this.value;
  }

}
